import * as universalMethods from './_universalmethods.js';
import assign from '../_helpers/assign.js';
import _afterInit from './_afterinit.js';
// the members Class() puts on the prototype; constructor joins in ./index.js
var instanceMembers = assign({
  _afterInit: _afterInit,
  isMatreshka: true,
  $: universalMethods.selectAll
}, universalMethods);
export default instanceMembers;